import classNames from 'classnames';
import { AnimatePresence } from 'framer-motion';
import { ReactNode, useMemo } from 'react';

import StickySidebar from '../../pages/BookingForm/components/StickySidebar/StickySidebar';

import styles from './SidebarAndMain.module.css';

type SidebarAndMainProps = {
    children: ReactNode;
    sidebar?: ReactNode;
};

const SidebarAndMain = ({ sidebar, children }: SidebarAndMainProps) => {
    const memoSidebar = useMemo(() => {
        return sidebar;
    }, [sidebar]);

    return (
        <div
            className={classNames(styles.Root, {
                [styles.hasSidebar]: !!sidebar,
                [styles.noSidebar]: !sidebar,
            })}
        >
            <div className={styles.SidebarWrapper}>
                <AnimatePresence>
                    {memoSidebar && (
                        <StickySidebar>{memoSidebar}</StickySidebar>
                    )}
                </AnimatePresence>
            </div>

            <div className={styles.Main}>{children}</div>
        </div>
    );
};

export default SidebarAndMain;
